module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vurin6-6e83d315a3a0f9d9925f126092c929d7.jpg";